import { useReCaptcha } from 'vue-recaptcha-v3';
import { DEFAULT_RECAPTCHA_CONFIG } from '../constants/recaptcha.constant';
import type {
  RetryOptions,
  UseRecaptchaV3Return,
} from '../types/recaptcha';

export function useRecaptchaV3(): UseRecaptchaV3Return {
  const reCaptcha = useReCaptcha();

  const execute = async (
    action: string,
    options: RetryOptions = {}
  ): Promise<string> => {
    if (!reCaptcha) return '';

    const {
      attempts = DEFAULT_RECAPTCHA_CONFIG.attempts,
      baseDelayMs = DEFAULT_RECAPTCHA_CONFIG.baseDelayMs,
      jitterMs = DEFAULT_RECAPTCHA_CONFIG.jitterMs,
    } = options;

    for (let attempt = 1; attempt <= attempts; attempt++) {
      const token = await executeAttempt(action);
      if (token) return token;
      if (attempt === attempts) return '';
      await delay(baseDelayMs, attempt, jitterMs);
    }
    return '';
  };

  const executeAttempt = async (action: string): Promise<string> => {
    if (!reCaptcha) return '';

    try {
      await reCaptcha.recaptchaLoaded();
      return (await reCaptcha.executeRecaptcha(action)) || '';
    } catch {
      return '';
    }
  };
  const delay = async (
    baseDelayMs: number,
    attempt: number,
    jitterMs: number
  ): Promise<void> => {
    const exponentialDelay = baseDelayMs * Math.pow(2, attempt - 1);
    const jitter = Math.random() * jitterMs;
    await new Promise((r) => setTimeout(r, exponentialDelay + jitter));
  };
  return { execute };
}
